import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

export const PrivateRoute = ({ children }) => {
  const { authToken } = useAuth();

  return authToken ? children : <Navigate to="/" />;
};